  import { ResponseTime } from '../../../types';
  
  export const setData = (scale: string, data: ResponseTime[], alertCutoff: number) => {
    data = data.map(time => {
      if(time.duration > alertCutoff) {
        time.alert = 20;
      } else time.alert = 0;
      return time;
    })
    return scale === "log" ? logScaleData(data) : data;
  }
  
  const logScaleData = (data: ResponseTime[]) => {
    const nadir = setNadir(data);
    if(nadir < 0.1) {
      return data.map(time => {
        time.duration = time.duration < 0.1 ? 0.1 : time.duration;
        return time;
      })
    } else return data;
  }
  const setNadir = (data: ResponseTime[]): number => {
    if(data.length > 0){
      return data.reduce((acc, time) => {
        acc = time.duration < acc ? time.duration : acc;
        return acc;
      }, data[0].duration);
    } else return 1;
  }



// WEBPACK FOOTER //
// ./src/components/AreaChart/utils/setData.ts